<template>
  <consult-contact-panel
    title="药食同源调理方案"
    subtitle="参照古中医组方思路，以超微饮片为调理人定制月方案、日方案、时方案"
    date-placeholder="请选择开始调理日期"
    future-date-message="调理日期必须大于当前日期"
    day-placeholder="请输入调理天数（不大于30天）"
    patient-section-title="调理人信息"
    patient-search-placeholder="请输入调理人姓名或出生日期"
    patient-add-button-text="创建调理人信息"
    patient-add-dialog-title="创建调理人信息"
    ill-day-placeholder="请选择状况开始日期"
    day-placeholder-monthly="请输入调理天数（不大于30天）"
    day-placeholder-daily="请输入调理天数（不大于3天）"
    month-label="月方案"
    day-label="日方案"
    hour-label="时方案"
    :show-use-days="true"
    :show-gan-zhi-controls="true"
    submit-button-text="开始咨询"
    :address-required="true"
    dialog-width="600px"
    :initial-contact="initialContact"
    :initial-use-date="initialUseDate"
    :initial-use-days="initialUseDays"
    :initial-gan-zhi-prescription-time-type="initialGanZhiPrescriptionTimeType"
    :initial-gan-zhi-prescription-hour-range="
      initialGanZhiPrescriptionHourRange
    "
    @back="goBack"
    @submit="onSubmit"
  />
</template>

<script>
import ConsultContactPanel from "../widgets/ConsultContactPanel.vue";

export default {
  components: { ConsultContactPanel },
  data() {
    return {
      initialContact: null,
      initialUseDate: "",
      initialUseDays: "",
      initialGanZhiPrescriptionTimeType: "",
      initialGanZhiPrescriptionHourRange: "",
    };
  },
  created() {
    const contact = sessionStorage.getItem("contactList");
    const consultInfo = sessionStorage.getItem("consultInfo");
    if (!this.utils.isEmptyStr(contact)) {
      this.initialContact = JSON.parse(contact);
      sessionStorage.removeItem("contactList");
      sessionStorage.removeItem("submitData");
      sessionStorage.removeItem("consultInfo");
      sessionStorage.removeItem("visitRecordId");
    } else if (!this.utils.isEmptyStr(consultInfo)) {
      const consultObj = JSON.parse(consultInfo);
      this.initialContact = consultObj.contact;
      this.initialUseDate = consultObj.useDate;
      this.initialUseDays = consultObj.useDays;
      this.initialGanZhiPrescriptionTimeType =
        consultObj.ganZhiPrescriptionTimeType || "";
      this.initialGanZhiPrescriptionHourRange =
        consultObj.ganZhiPrescriptionHourRange || "";
    }
  },
  methods: {
    goBack() {
      if (!this.utils.isEmptyStr(this.fromPath) && this.fromPath != "/")
        this.$router.go(-1);
      else this.$router.replace("/");
    },
    onSubmit(payload) {
      sessionStorage.removeItem("visitRecordId");
      const consultInfo = {
        contact: payload.selectContact,
        useDate: payload.useDate,
        ganZhiPrescriptionTimeType: payload.ganZhiPrescriptionTimeType,
        useDays: payload.useDays,
        ganZhiPrescriptionHourRange: payload.ganZhiPrescriptionHourRange,
      };
      sessionStorage.setItem("consultInfo", JSON.stringify(consultInfo));
      sessionStorage.removeItem("submitData");
      this.$router.push({ path: "/chaoweiPrescriptionInfo" });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromPath = from.path;
    });
  },
};
</script>
